import Backbone from 'backbone';
import ko from 'knockout';
import template from '@bingads-webui-campaign-legacy/budget/template/bid-suggestion-popup.pug';
import ViewModel from '@bingads-webui-campaign-legacy/budget/viewmodel/bid-suggestion-popup';

export default class View extends Backbone.View {
  initialize(options) {
    this.i18n = options.i18n;
    this.options = options;
    this.koModel = new ViewModel(this.i18n, this.options.suggestedBid, this.options.bidHintKey, this.options.suggestedClicks, this.options.impressionsMore, this.options.newI18n);
  }

  get events() {
    return {
      'click .apply': 'apply',
      'click .cancel': 'cancel',
      'click .apply-link': 'apply',
      'click .cancel-link': 'cancel',
      'click .close': 'cancel',
      'click .close-button': 'cancel',
    };
  }

  updateSuggestedBid(suggestedBid) {
    this.koModel.suggestedBid(suggestedBid);
  }

  cancel() {
    this.$el.hide();
  }

  apply() {
    this.options.callback(this.koModel.suggestedBid());
    if (this.activityLogger) {
      this.activityLogger.signal({
        Scenario: 'CampaignCreation',
        SuggestedBid: this.options.suggestedBid,
        OriginalInputBid: this.options.Bid,
        EventName: 'CreationFlowLowBidSuggestionApply',
        SuggestedBidRequestId: this.options.suggestedBidRequestId,
      }
      );
    }
    this.cancel();
  }

  render () {
    this.$el.html(template({ i18n: this.i18n }));
    ko.applyBindings(this.koModel, this.el);
    return this;
  }
}
